import * as React from "react";
const SvgStepInIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 16, viewBox: "0 0 10 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 0H3V6H0L5 16L10 6H7V0Z", fill: "currentColor" }));
export default SvgStepInIcon;
